import AccountMessaginComponent from './AccountMessaginComponent';

export default AccountMessaginComponent;